import { ModelBase } from '../abstract/model-base.model';

export class BankingSettings extends ModelBase {

    static override CLASS_NAME: string = 'BankingSettings';

    // Sous-modules actifs
    private _enableBankStatements!: boolean;
    private _enableCardReceipts!: boolean;
    private _enableCashTransactions!: boolean;
    private _enableCheque!: boolean;
    private _enableCreditCardTransactions!: boolean;
    private _enableLoans!: boolean;

    // Automatisations
    private _enableAutoMatching!: boolean;
    private _enableMemoryQualification!: boolean;

    public get enableAutoMatching(): boolean {
        return this._enableAutoMatching;
    }

    public set enableAutoMatching(value: any) {
        this._setValue('_enableAutoMatching', value, 'boolean');
    }

    public get enableBankStatements(): boolean {
        return this._enableBankStatements;
    }

    public set enableBankStatements(value: any) {
        this._setValue('_enableBankStatements', value, 'boolean');
    }

    public get enableCardReceipts(): boolean {
        return this._enableCardReceipts;
    }

    public set enableCardReceipts(value: any) {
        this._setValue('_enableCardReceipts', value, 'boolean');
    }

    public get enableCashTransactions(): boolean {
        return this._enableCashTransactions;
    }

    public set enableCashTransactions(value: any) {
        this._setValue('_enableCashTransactions', value, 'boolean');
    }

    public get enableCheque(): boolean {
        return this._enableCheque;
    }

    public set enableCheque(value: any) {
        this._setValue('_enableCheque', value, 'boolean');
    }

    public get enableCreditCardTransactions(): boolean {
        return this._enableCreditCardTransactions;
    }

    public set enableCreditCardTransactions(value: any) {
        this._setValue('_enableCreditCardTransactions', value, 'boolean');
    }

    public get enableLoans(): boolean {
        return this._enableLoans;
    }

    public set enableLoans(value: any) {
        this._setValue('_enableLoans', value, 'boolean');
    }

    public get enableMemoryQualification(): boolean {
        return this._enableMemoryQualification;
    }

    public set enableMemoryQualification(value: any) {
        this._setValue('_enableMemoryQualification', value, 'boolean');
    }

}
